import { CategoryDataResponse, CommonResponse } from '../interfaces/categories';
import axiosInstance from '../axios';
import { AxiosError } from 'axios';

/**
 * Service for fetching category data from the API
 */
export const CategoryService = {
  /**
   * Get all categories
   * @returns Promise with the categories data
   */
  getCategories: async (): Promise<CommonResponse> => {
    try {
      const response = await axiosInstance.get('/category/search/');
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      return {
        response_status: false,
        response_message: error instanceof Error ? error.message : 'Unknown error',
        response_data: []
      };
    }
  },

  /**
   * Get category detail by ID
   * @param id - Category ID
   * @returns Promise with the category detail
   */
  getCategoryDetail: async (id: string): Promise<CategoryDataResponse> => {
    try {
      const response = await axiosInstance.get(`/category/category/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching category detail:', error);
      return {
        response_status: false,
        response_message: error instanceof Error ? error.message : 'Unknown error',
        response_data: {} as any,
        pagination: {}
      };
    }
  },

  /**
   * Get category filters
   * @param id - Category ID
   * @returns Promise with the category filters
   */
  getCategoryFilters: async (id: string): Promise<CommonResponse> => {
    try {
      const response = await axiosInstance.get(`/category/filters/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching category filters:', error);
      return {
        response_status: false,
        response_message: error instanceof Error ? error.message : 'Unknown error',
        response_data: []
      };
    }
  },

  /**
   * Get category detail by slug
   * @param slug - Category slug
   * @returns Promise with the category detail
   */
  getCategoryDetailBySlug: async (slug: string): Promise<CategoryDataResponse> => {
    try {
      const response = await axiosInstance.get(`/category/category/slug/${slug}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching category detail by slug:', error);
      return {
        response_status: false,
        response_message: error instanceof Error ? error.message : 'Unknown error',
        response_data: {} as any,
        pagination: {},
        http_status: error instanceof AxiosError ? error.response?.status : undefined,
      };
    }
  }
};
